// Your direction autosave (Odin's ruling 2026-10-28): Generate and Regenerate
// in a stage panel save whatever is typed in its Your direction boxes first,
// so a note typed but not saved is never silently left out of the call.

// One box's save: true once its text is saved (or nothing needed saving),
// false when the save failed (the box shows the error itself).
export type DraftSave = () => Promise<boolean>;

// The same comparison the box uses for "changed": whitespace runs collapsed, trimmed.
export function draftChanged(draft: string, saved: string): boolean {
  return draft.replace(/\s+/g, ' ').trim() !== saved;
}

// Saves every unsaved box in turn and stops at the first failure.
export async function saveDrafts(saves: Iterable<DraftSave>): Promise<boolean> {
  for (const save of [...saves]) {
    if (!(await save())) return false;
  }
  return true;
}
